var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDownArrowWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 8,
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.862 0.861816L11.8048 1.80463L6.00005 7.60936L0.195312 1.80463L1.13812 0.861816L6.00005 5.72375L10.862 0.861816Z",
  fill: "white"
})));
export { SvgDownArrowWhite as ReactComponent };
export default __webpack_public_path__ + "e723e904ec63e31a78aeb0da5f8c58d1.svg";